
<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/fondo_tuyro.webp"
  style="background-image: url('assets/img/fondo_libro.jpeg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
        <div class="col-md-12 logo_gerencia">
            <img src="/assets/img/logo_grd.png" alt="" class="logo_gerencia_imagen" style="width: 150px;">
        </div>
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white">
          <h3 style="color: white">
            <span class="textodelgado">CETPRO</span><br>
            <span class="textogordo">TOMAS TURO TUPAC</span> <br>
            <!-- <span class="textodelgado"> del Centro Histórico del Cusco</span> -->
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="welcome-section pt-80 pt-pd-60 pt-40" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-12 m-auto text-center">
        <div class="section-title-wrap">
          <h2>INTERVENCIÓN EN EL CETPRO TOMAS TUYRO TUPAC INCA</h2>
          <p class="mb-0" style="font-weight: 300;">
            El <b>Centro de Educación Técnico Productiva “JUAN TOMAS TUYRO TUPAC INCA”</b> fue creado en <b>1959</b>. Inicialmente, 
            funcionó como un taller de artes manuales en la escuela pre-vocacional de Sivirichi, en la calle Arones, 
            Cusco. A lo largo de los años, la institución se trasladó a diferentes ubicaciones: en 1961 a la escuela de 
            Colcampata en la calle Arco Iris, y en 1964 a la calle Santa Teresa. En 1975, con la reforma de la Educación, 
            tomó el nombre de <b>Centro de Calificación Profesional Extraordinaria Juan Tomás Tuyro Tupac Inca</b>, 
            luego <b>Centro de Educación Ocupacional</b> y, a partir del año 2005, funciona como <b>Centro de Educación Técnico Productiva</b>. 
            En abril del 2024, el CETPRO cumplió 65 años de vida institucional.
          </p>
          <br>
        </div>

        <div class="page-wrapper">
            <article class="port-details-page-wrap">
                <div class="port-details-header">
                    <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 3, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
                        <figure class="port-details-thumb-item">
                            <a href="assets/img/tuyro1.webp" class="btn-img-gallery">
                                <img src="assets/img/tuyro1.webp" alt="Portfolio">
                            </a>
                        </figure>
                        <figure class="port-details-thumb-item">
                          <a href="assets/img/tuyro2.webp" class="btn-img-gallery">
                              <img src="assets/img/tuyro2.webp" alt="Portfolio">
                          </a>
                        </figure>
                        <figure class="port-details-thumb-item">
                            <a href="assets/img/tuyro3.webp" class="btn-img-gallery">
                                <img src="assets/img/tuyro3.webp" alt="Portfolio">
                            </a>
                        </figure>
                    </div>
                </div>
            </article>
          </div>

        <div class="col-md-12" style="margin-top: 70px !important;">
            <h3 class="text-center">MANUAL DE INTERVENCIÓN</h3>
            <p class="mb-0" style="font-weight: 300;">
                <b>La Municipalidad Provincial del Cusco</b>, como entidad
                comprometida con la preservación y conservación del
                patrimonio cultural de nuestra ciudad, se complace en
                presentar este manual de intervención en inmuebles.
                Así mismo la <b>Gerencia de Centro Histórico</b> tiene como misión
                principal velar por el cuidado y protección de los inmuebles
                históricos y patrimoniales que conforman nuestro querido
                Cusco. Reconocemos la importancia de mantener viva
                nuestra herencia arquitectónica y garantizar su legado para
                las generaciones futuras.
            </p>
            <br>
            <p style="font-weight: 300;">
                Este manual ha sido elaborado con la finalidad de
                proporcionar a profesionales, técnicos y ciudadanos, las
                herramientas necesarias para llevar a cabo intervenciones
                adecuadas y respetuosas en los inmuebles de nuestra ciudad.
                A través de estas líneas, se compartirá con la ciudadanía
                conocimientos, buenas prácticas y directrices que permitirán
                realizar intervenciones de calidad, basadas en los principios
                de respeto a la integridad histórica así como para unificar
                los criterios de conservación y e intervención en inmuebles
                patrimoniales.
            </p>
            
            <p style="font-weight: 300;">
                La Municipalidad Provincial del Cusco se enorgullece en
                poner a disposición este valioso recurso que contribuirá
                a la protección y valoración de nuestro patrimonio
                arquitectónico. Invitamos a todos los interesados a utilizar
                este manual como una referencia confiable y útil en sus
                proyectos de intervención en inmuebles.
            </p>
            <div style="display: flex; flex-direction: row; justify-content: center; width: 100%;">
              <a href="https://drive.google.com/uc?export=download&id=1-j4I8tPz3UNyJBDhyfaQCCS8MEd4o_7A" class="btn btn-brand" target="_blank" style="background-color:#821644;margin-top:30px;margin-bottom: 30px !important;">Descargar el Manual de Intervención</a>
            </div>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="page-wrapper"
  style="background-image: url('/assets/img/fondo-leyenda-catalogacion.png'); background-size: cover; background-position: center;">
  <div class="accordion-content-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <iframe style="width:100%;height:700px" src="https://online.anyflip.com/zdbmc/trpb/index.html"  seamless="seamless" scrolling="no" frameborder="0" allowtransparency="true" allowfullscreen="true" ></iframe>
        </div>
      </div>
    </div>
  </div>
</div>



<section class="welcome-section pt-80 pt-pd-60 pt-40" style="">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-12 m-auto text-center">
        <div class="col-md-12">
            <h3 class="text-center">VISTA 3D DEL CETPRO</h3>
            <p class="mb-0" style="font-weight: 300;">
                En esta representación tridimensional  podrán explorar nuestras instalaciones, 
                que incluyen aulas modernas, talleres equipados y áreas recreativas. Esta visualización permite apreciar 
                la infraestructura diseñada para fomentar el aprendizaje práctico y teórico. 
            </p>
            <br>
        </div>
      </div><!-- End Section title -->
    </div>
  </div>
</section>

<div class="row">
    <iframe src="https://coderdir.autodesk360.com/shares/public/SH286ddQT78850c0d8a4e4ca0c8d590fdf09?mode=embed" width="100%" height="700" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"  frameborder="0"></iframe>
</div>

<style>
.logo_gerencia_imagen{
    width: 150px !important;
}
.logo_gerencia{
    display: flex; 
    flex-direction: row; 
    justify-content: center; 
    width: 100px !important; 
    margin-top: 180px !important;
}
.textodelgado{
    font-weight: 100 !important;
    font-size: 25px;
}

.textogordo{
    font-weight: bolder !important;
    font-size: 25px;
}
@media only screen and (min-width: 768px) and (max-width: 991.98px), only screen and (max-width: 767.98px){
    .about-us-content {
            font-size: 14px;
            padding: 0px;
    }
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100px !important;
        margin-top: 250px !important;
        margin-bottom: -100px;
    }
}

@media (max-width: 425px){
    .logo_gerencia {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100% !important;
        margin-top: 140px !important;
        margin-bottom: 0px;
    }
    .logo_gerencia_imagen{
        width: 100px !important;
    }
    .textodelgado{
        font-weight: 100 !important;
        font-size: 17px;
    }
    .textogordo{
        font-weight: bolder !important;
        font-size: 17px;
    }
}
</style>